import { UserNavigationBar } from '@vivaldis/antd-ui'
import { MenuWithAvatar } from '../Header/components/MenuWithAvatar'
import { OnboardingNavigationSteps } from './components/OnboardingNavigationSteps'

export const NavigationBarForOnboarding = () => {
  return (
    <UserNavigationBar navigationItems={<OnboardingNavigationSteps />}>
      <MenuWithAvatar />
    </UserNavigationBar>
  )
}
